import React, { useEffect, useRef, useState } from "react";
import {
  View,
  Text,
  Image,
  ImageBackground,
  TouchableOpacity,
  StyleSheet,
  Dimensions,
  ScrollView,
} from "react-native";
import {
  BlueButton,
  BonusGInfoBtn,
  EntryChipsIcon,
  InvitedPlayerBackground,
  LeftArrowPng,
  MainUsersLiveFramePng,
  RewardChips,
  RewardsBlueLight,
  RewardsBronzeLight,
  RewardsPurpleLight,
  SignupBtn,
  TournamentChipsIcon,
  TropheeBronze,
  TropheeGold,
  TropheeSilver,
  VipBadgeFramePng,
} from "../../../assets";
import { useDevice } from "../../../utils/hooks/useDevice";
import { useNavigation } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { RootStackParamList } from "../../navigator";
import { useRoute } from "@react-navigation/native";
import { RouteProp } from "@react-navigation/native";
import { useDispatch } from "react-redux";
import PlayerCard from "./PlayerCard";
import SignedPlayers from "./SignedPlayers";
import { SnG } from "../Middle/TournamentsSection";
import TournamentRulesModal from "../Modals/TournamentRulesModal";
import { useTournamentRegistration } from "./useTournamentRegistration";
import { tournamentsListRefreshRequest } from "../../../store/tournaments/tournamentsActions";
import { useTranslation } from "react-i18next";
type TournamentRoute = RouteProp<RootStackParamList, "Tournament">;
type Nav = NativeStackNavigationProp<RootStackParamList>;

const TournamentDetails: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { height, width } = useDevice();
  const isDesktop = width >= 1180;
  const isTablet = width < 1180 && width > 760;
  const { params } = useRoute<TournamentRoute>();
  const { tournamentId, roomId } = params;
  const [isInfoModalVisible, setIsInfoModalVisible] = useState(false);

  const {
    playerId,
    signedPlayers,
    isSigned,
    details,
    sng,
    registerLoading,
    handleRegisterPress,
  } = useTournamentRegistration({ tournamentId, roomId });

  const TOTAL_SEATS = 8;
  const playerCount = signedPlayers.length;
  const emptySlots = Math.max(0, TOTAL_SEATS - playerCount);

  const missingRoomId = !roomId;
  if (missingRoomId) {
    console.warn("❌ TournamentDetails: missing roomId", { tournamentId });
  }

  const formatChips = (n: any) => {
    const num = typeof n === "number" ? n : Number(n ?? 0);
    return num
      .toLocaleString("en-US", { maximumFractionDigits: 0 })
      .replace(/,/g, ".");
  };

  const [timeLeft, setTimeLeft] = useState({
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  const chipsArray: number[] = Array.isArray(sng?.prices)
    ? sng?.prices.map((x: any) => Number(x ?? 0))
    : Object.values(sng?.prices ?? {})
        .sort((a, b) => Number(b) - Number(a))
        .map((k) => Number(k ?? 0));

  const rewards = [
    {
      img: TropheeSilver,
      color: "#6FEFFF",
      divider: RewardsBlueLight,
      chipsValue: formatChips(chipsArray[1] ?? 0),
    },
    {
      img: TropheeGold,
      color: "#FFD54F",
      divider: RewardsBronzeLight,
      chipsValue: formatChips(chipsArray[0] ?? 0),
      vipDaysValue: Number(details?.vip_days_reward ?? 0),
    },

    {
      img: TropheeBronze,
      color: "#FF925C",
      divider: RewardsPurpleLight,
      chipsValue: formatChips(chipsArray[2] ?? 0),
    },
  ];

  const entryFee = Number(sng?.entry_size ?? sng?.entry_size ?? 0);

  const tournamentChips = Number(
    details?.tournament_chips ?? sng?.tournament_chips ?? 0,
  );

  const entryItems = [
    {
      label: t("T_SITE_TOURNAMENT_PLAYERS_ENTRY"),
      icon: EntryChipsIcon,
      color: "#FFD54F",
      value: formatChips(entryFee),
    },
    {
      label: t("T_SITE_TOURNAMENT_PLAYERS_CHIPS"),
      icon: TournamentChipsIcon,
      color: "#6FEFFF",
      value: formatChips(tournamentChips),
    },
  ];

  const targetTime = details?.start_in || details?.close_at;
  const navigation = useNavigation<NativeStackNavigationProp<RootStackParamList>>();
  const hasExpiredHandledRef = useRef(false);

  useEffect(() => {
    const updateCountdown = () => {
      if (!targetTime) {
        setTimeLeft({
          hours: "00",
          minutes: "00",
          seconds: "00",
        });
        return;
      }

      const future = new Date(targetTime).getTime();
      const now = Date.now();
      const diff = Math.max(future - now, 0);

      const h = Math.floor(diff / (1000 * 60 * 60));
      const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const s = Math.floor((diff % (1000 * 60)) / 1000);

      const pad = (n: number) => String(n).padStart(2, "0");
      setTimeLeft({
        hours: pad(h),
        minutes: pad(m),
        seconds: pad(s),
      });

      // When countdown expires, refresh list and always redirect to lobby.
      if (diff <= 0 && !hasExpiredHandledRef.current) {
        hasExpiredHandledRef.current = true;
        dispatch(tournamentsListRefreshRequest());
        navigation.navigate("Lobby" as never);
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [targetTime, navigation, dispatch]);

  const timerData = [
    { value: timeLeft.hours, label: t("T_SITE_TOURNAMENT_HOURS") },
    { value: timeLeft.minutes, label: t("T_SITE_TOURNAMENT_MINUTES") },
    { value: timeLeft.seconds, label: t("T_SITE_TOURNAMENT_SECONDS") },
  ];
  const timerWidth = isDesktop ? 180 : 150;
  const handlePrev = () => {
    if (navigation.canGoBack()) navigation.goBack();
    else navigation.navigate("Tournaments" as any);
  };

  const openInfoModal = () => {
    setIsInfoModalVisible(true);
  };

  const closeInfoModal = () => {
    setIsInfoModalVisible(false);
  };

  console.log(details);
  useEffect(() => {
    console.log("details changed:", details);
  }, [details]);

  return (
    <View style={{ flex: 1 }}>
      <ScrollView
        style={{ flex: 1 }}
        contentContainerStyle={{ paddingBottom: 40 }}
        showsVerticalScrollIndicator={false}
        nestedScrollEnabled
        keyboardShouldPersistTaps="handled"
      >
        <View
          style={[
            styles.container,
            {
              flexDirection: isDesktop ? "row" : "column",
              // flexDirection: "column",
              justifyContent: "space-around",
              paddingVertical: isDesktop ? 12 : 2,
              marginTop: isDesktop ? 10 : 0,
              minHeight: isDesktop ? height * 0.4 : undefined,
            },
          ]}
        >
          <View
            style={[
              styles.container,
              {
                // flexDirection: isDesktop ? "row" : "column",
                flexDirection: "column",
                // flexGrow: 0,

                paddingVertical: isDesktop ? 12 : 2,
                marginTop: isDesktop ? 0 : 0,
                minHeight: isDesktop ? height * 0.4 : undefined,
              },
            ]}
          >
            {/* LEFT */}
            <View
              style={[
                styles.leftCol,
                { minHeight: isDesktop ? height * 0.3 : undefined },
              ]}
            >
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: isDesktop ? 10 : 10,
                  marginBottom: isDesktop ? 10 : 4,
                }}
              >
                <TouchableOpacity style={styles.arrowLeft} onPress={handlePrev}>
                  <ImageBackground
                    source={LeftArrowPng}
                    resizeMode="cover"
                    style={styles.arrowBg}
                    imageStyle={styles.arrowImg}
                  />
                </TouchableOpacity>
                <View>
                  <Image
                    source={RewardsPurpleLight}
                    style={styles.rewardsDivider}
                    resizeMode="stretch"
                  />
                  <Text
                    style={[
                      styles.rewardsTitle,
                      isDesktop ? styles.textDesktop : styles.textMobile,
                    ]}
                  >
                    {t("T_Rewards")}
                  </Text>
                  <Image
                    source={RewardsPurpleLight}
                    style={styles.rewardsDivider}
                    resizeMode="stretch"
                  />
                </View>

                <View style={styles.participantsWrap}>
                  <TouchableOpacity onPress={openInfoModal}>
                    <ImageBackground
                      source={BonusGInfoBtn}
                      style={styles.infoStyle}
                    ></ImageBackground>
                  </TouchableOpacity>
                </View>

                {/* {isDesktop && (
                  <View style={styles.participantsWrap}>
                    <ImageBackground
                      source={MainUsersLiveFramePng}
                      style={styles.badgeStyle}
                    >
                      <Text
                        numberOfLines={1}
                        ellipsizeMode="tail"
                        style={styles.textStyle}
                      >
                        {Array.isArray(sng?.players) ? sng.players.length : 0}/8
                      </Text>
                    </ImageBackground>
                  </View>
                )} */}
              </View>

              <View
                style={[
                  styles.rewardsRow,
                  {
                    marginTop: isDesktop ? 0 : 2,
                    width: isDesktop ? "76%" : "100%",
                    flexWrap: isDesktop ? "nowrap" : "wrap",
                  },
                ]}
              >
                {rewards.map((trophy, i) => (
                  <View
                    key={i}
                    style={[
                      styles.trophyItem,
                      {
                        marginHorizontal: isDesktop ? 10 : 4,
                        marginBottom: isDesktop ? 8 : 2,
                      },
                    ]}
                  >
                    <Image
                      source={trophy.img}
                      style={{
                        width: isDesktop ? 140 : "100%",
                        height: isDesktop ? 140 : 130,
                        marginBottom: -12,
                      }}
                      resizeMode="contain"
                    />
                    <View style={styles.rewardValueRow}>
                      <Image
                        source={RewardChips}
                        style={{
                          width: isDesktop ? 45 : 32,
                          height: isDesktop ? 45 : 26,
                        }}
                        resizeMode="contain"
                      />
                      <Text
                        style={[
                          styles.rewardValue,
                          {
                            fontSize: isDesktop ? 22 : 18,
                            fontWeight: isDesktop ? "700" : "700",
                            color: trophy.color,
                          },
                        ]}
                      >
                        {trophy.chipsValue}
                      </Text>
                    </View>
                    {/* <Image
                      source={trophy.divider}
                      style={{ width: isDesktop ? 170 : "80%", height: 10 }}
                      resizeMode="stretch"
                    /> */}
                    <View style={styles.rewardValueRow}>
                      {trophy?.vipDaysValue != null &&
                        trophy.vipDaysValue > 0 && (
                          <>
                            <Image
                              source={VipBadgeFramePng}
                              style={{
                                width: isDesktop ? 26 : 24,
                                height: isDesktop ? 26 : 20,
                              }}
                              resizeMode="contain"
                            />

                            <Text
                              style={[
                                styles.rewardValue,
                                {
                                  fontSize: isDesktop ? 16 : 16,
                                  fontWeight: isDesktop ? "700" : "700",
                                  color: "#FFD54F",
                                  marginLeft: 4,
                                },
                              ]}
                            >
                              {trophy.vipDaysValue}
                              {trophy.vipDaysValue === 1
                                ? t("T_SITE_TOURNAMENT_DAY")
                                : t("T_SITE_TOURNAMENT_DAYS")}
                            </Text>
                          </>
                        )}
                    </View>
                  </View>
                ))}
              </View>
            </View>

            {/* RIGHT */}
            <View
              style={[
                styles.rightCol,
                { minHeight: isDesktop ? height * 0.3 : undefined },
              ]}
            >
              <Image
                source={RewardsPurpleLight}
                style={{
                  width: 420,
                  height: isDesktop ? 12 : 9,
                  marginBottom: 2,
                }}
                resizeMode="stretch"
              />

              <View style={styles.entryRow}>
                {entryItems.map((item, idx) => (
                  <React.Fragment key={item.label}>
                    {idx === 1 && (
                      <Text
                        style={{
                          fontSize: isDesktop ? 36 : 24,
                          color: "#E5E5E5",
                          fontWeight: "900",
                        }}
                      >
                        ＝
                      </Text>
                    )}
                    <View style={styles.entryItem}>
                      <Text
                        style={{
                          color: "#FFFFFF",
                          fontSize: isDesktop ? 18 : 14,
                          fontWeight: "700",
                          textTransform: "uppercase",
                        }}
                      >
                        {item.label}
                      </Text>
                      <View style={styles.entryValueRow}>
                        <Image
                          source={item.icon}
                          style={{
                            width: isDesktop ? 24 : 24,
                            height: isDesktop ? 24 : 24,
                          }}
                          resizeMode="contain"
                        />
                        <Text
                          style={{
                            fontSize: isDesktop ? 22 : 18,
                            fontWeight: isDesktop ? "600" : "700",
                            textShadowColor: "#000",
                            textShadowOffset: { width: 1, height: 2 },
                            textShadowRadius: 3,
                            color: item.color,
                            marginLeft: 6,
                          }}
                        >
                          {item.value}
                        </Text>
                      </View>
                      <Image
                        source={RewardsPurpleLight}
                        style={{ width: isDesktop ? 260 : 100, height: 6 }}
                        resizeMode="stretch"
                      />
                    </View>
                  </React.Fragment>
                ))}
              </View>

              {targetTime && (
                <>
                  <Text
                    style={{
                      color: "#fff",
                      textAlign: "center",
                      fontSize: isDesktop ? 14 : 10,
                      marginVertical: isDesktop ? 10 : 2,
                    }}
                  >
                    {t("T_SITE_TOURNAMENT_TIMER_CLOSE")}
                    {"\n"}
                    {t("T_SITE_TOURNAMENT_TIMER_CLOSE2")}
                  </Text>

                  <View style={[styles.timerBox, { width: timerWidth }]}>
                    {timerData.map((t, i) => (
                      <React.Fragment key={t.label}>
                        {i > 0 && (
                          <Text
                            style={{
                              color: "#FFFFFF",
                              fontSize: isDesktop ? 24 : 16,
                              fontWeight: "800",
                            }}
                          >
                            :
                          </Text>
                        )}
                        <View style={styles.timerUnit}>
                          <Text
                            style={{
                              color: "#FFFFFF",
                              fontSize: isDesktop ? 20 : 16,
                              fontWeight: isDesktop ? "700" : "700",
                            }}
                          >
                            {t.value}
                          </Text>
                          <Text
                            style={{
                              color: "#FFCC33",
                              fontWeight: isDesktop ? "700" : "700",
                              fontSize: isDesktop ? 10 : 8,
                              marginTop: 2,
                            }}
                          >
                            {t.label}
                          </Text>
                        </View>
                      </React.Fragment>
                    ))}
                  </View>
                </>
              )}

              <ImageBackground
                source={BlueButton}
                style={{
                  minWidth: timerWidth,
                  minHeight: isDesktop ? 56 : 42,
                  marginTop: isDesktop ? 10 : 12,
                  alignSelf: "center",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingHorizontal: isDesktop ? 24 : 18,
                  paddingVertical: isDesktop ? 10 : 6,
                }}
                resizeMode="stretch"
              >
                <TouchableOpacity
                  activeOpacity={0.9}
                  disabled={registerLoading}
                  onPress={handleRegisterPress}
                  style={{
                    alignSelf: "stretch",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Text
                    style={{
                      fontSize: isDesktop ? 20 : 16,
                      fontWeight: "700",
                      color: "#ffffff",
                      textAlign: "center",
                      maxWidth: isDesktop ? 420 : 260,
                    }}
                  >
                    {isSigned
                      ? t("T_SITE_TOURNAMENT_UNREGISTER")
                      : t("T_SITE_TOURNAMENT_REGISTER")}
                  </Text>
                </TouchableOpacity>
              </ImageBackground>
            </View>
          </View>
          <View
            style={[
              styles.container,
              {
                paddingBottom: isDesktop ? 20 : 100,
                marginTop: isDesktop ? 40 : 0,
                minHeight: height * 0.2,
              },
            ]}
          >
            <View
              style={{
                width: isDesktop ? 500 : "100%",
                margin: "auto",
                backgroundColor: "rgba(17, 35, 69, 0.8)",
                minWidth: isDesktop ? 500 : 320,
                minHeight: height * 0.4,
                borderRadius: 14,
                overflow: "hidden",
              }}
            >
              <View style={{ width: "100%" }}>
                {signedPlayers.map((player) => (
                  <SignedPlayers
                    key={player.id}
                    name={player.name}
                    score={player.score}
                    chips={player.chips}
                    avatarImage={player.avatarImage}
                    backgroundImage={InvitedPlayerBackground}
                  />
                ))}
              </View>
              <View
                style={{
                  width: "100%",
                  marginTop: isDesktop ? 6 : 0,
                  borderRadius: 14,
                  // overflow: "hidden",
                }}
              >
                {Array.from({ length: emptySlots }).map((_, index) => (
                  <PlayerCard key={`empty-${index}`} />
                ))}
              </View>
            </View>
          </View>
        </View>
      </ScrollView>
      <TournamentRulesModal
        visible={isInfoModalVisible}
        onClose={closeInfoModal}
        isDesktop={isDesktop}
        width={width}
      />
    </View>
  );
};

export default TournamentDetails;

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
    marginBottom: 14,
  },
  leftCol: {
    alignItems: "center",
  },
  rewardsDivider: {
    width: 260,
    height: 6,
  },
  rewardsTitle: {
    color: "#E5E5E5",
    textTransform: "uppercase",
    textShadowColor: "#000",
    textShadowOffset: { width: 1, height: 2 },
    textShadowRadius: 3,
    marginBottom: 6,
    textAlign: "center",
  },
  textDesktop: {
    fontSize: 24,
    fontWeight: "700",
  },
  textMobile: {
    fontSize: 20,
    fontWeight: "700",
  },
  rewardsRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  trophyItem: {
    alignItems: "center",
    width: "30%",
  },
  rewardValueRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 4,
  },
  rewardValue: {
    textShadowColor: "#000",
    textShadowOffset: { width: 1, height: 2 },
    textShadowRadius: 3,
  },
  rightCol: {
    alignItems: "center",
  },
  entryRow: {
    flexDirection: "row",
  },
  entryItem: {
    alignItems: "center",
    marginBottom: 8,
  },
  entryValueRow: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 4,
  },
  timerBox: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#0E2337",
    borderColor: "#FFCC33",
    borderWidth: 2,

    borderRadius: 10,
    alignSelf: "center",
  },
  timerUnit: {
    alignItems: "center",
    paddingHorizontal: 6,
  },
  arrowLeft: {
    // position: "absolute",
    // top: "45%",
    // left: 10,
    // borderRadius: 20,
    // zIndex: 10,
  },
  arrowRight: {
    // position: "absolute",
    // top: "45%",
    // right: 10,
    // borderRadius: 20,
    // zIndex: 10,
  },
  arrowBg: {
    width: 50,
    height: 50,
    justifyContent: "center",
    alignItems: "center",
    padding: 10,
    borderRadius: 20,
  },
  arrowImg: {
    borderRadius: 20,
  },
  participantsWrap: {
    width: 30,
  },
  badgeStyle: {
    position: "absolute",
    width: 50,
    height: 50,
  },
  infoStyle: {
    position: "absolute",
    width: 44,
    height: 44,
  },
  textStyle: {
    position: "absolute",
    color: "#ffe593",
    fontSize: 11,
    width: 20,
    top: 24,
    right: 14,
    textAlign: "center",
  },
});
